export default "__VITE_ASSET__C0i1bm2L__"